import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes", "menuItems"];
import I18n from 'I18n';
// @ts-expect-error TS7016, tinymce has not yet been migrated.
import tinymce from 'tinymce';
import UITooltip from 'UIComponents/tooltip/UITooltip';
// @ts-expect-error TS7016, StyleProtectedTransparentButton has not yet been migrated.
import TransparentButton from 'rich-text-lib/components/style-protected/StyleProtectedTransparentButton';
import { getFetchPaths } from 'tinymce-data/api/DataTokens';
import Routes from 'ContentUtils/Routes';
import { HS_DATA_TOKEN } from '../constants/plugins';
import { CANVAS_PERSONALIZE } from '../constants/toolbar';
import { getHandleInsert, getHandleUpdate, getTokenRemoveHandler } from './handlers';
import { isEditableToken } from '../utils/token';
// @ts-expect-error TS7016, DataTokenPopoverManager has not yet been migrated.
import DataTokenPopoverManager from '../components/DataTokenPopoverManager';
import DataTokenTooltipManager from '../components/DataTokenTooltipManager';
import { getPickerComponent } from '../utils/settings';
import { jsx as _jsx } from "react/jsx-runtime";
export const addControls = (editor, dataTokenConfig, useAsUpgradePoint) => {
  if (useAsUpgradePoint) {
    const PersonalizationUpgradeButton = getPickerComponent(editor, 'PersonalizationUpgradeButton', '`PersonalizationUpgradeButton` codesplit component is required for the personalization upgrade point');
    tinymce.canvas.addButton(editor, CANVAS_PERSONALIZE, {
      renderControl: () => {
        return /*#__PURE__*/_jsx(PersonalizationUpgradeButton, {
          children: I18n.text('TinymcePlugins.hsdatatoken.button')
        });
      }
    });
    return;
  }
  const {
    apiClient
  } = editor.settings;
  const fetchPaths = getFetchPaths(apiClient, dataTokenConfig);
  const browserProps = {
    dataTokenConfig,
    dropdownClassName: 'mce-hubspot-menu',
    fetchPaths,
    emailSettingsLink: `${editor.settings.appUrl}${Routes.settings('email', 'personalization')}`,
    publishingSettingsLink: `${editor.settings.appUrl}${Routes.settings('publishing')}/all-domains/personalization`
  };
  const handleInsertToken = getHandleInsert(editor);
  const handleEditToken = getHandleUpdate(editor);
  const handleClick = ({
    isActive
  }) => {
    if (!isActive) {
      editor.fire('OpenPersonalizePopover');
    }
  };
  const isActiveHandler = ({
    element
  }) => {
    if (!element) return false;
    return isEditableToken(editor, element);
  };
  tinymce.canvas.addButton(editor, CANVAS_PERSONALIZE, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(UITooltip, {
        title: I18n.text('TinymcePlugins.hsdatatoken.tooltip.insert'),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(TransparentButton, Object.assign({
          "data-test-id": "insert-data-token-button",
          use: "transparent",
          onClick: () => {
            handleClick({
              isActive: isActiveHandler({
                element: editor.selection.getNode()
              })
            });
          }
        }, rest, {
          children: I18n.text('TinymcePlugins.hsdatatoken.button')
        }))
      });
    }
  });
  const isActiveNodeHandler = ({
    element
  }) => {
    if (!element) return false;
    return isEditableToken(editor, element) && element;
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    eventKey: HS_DATA_TOKEN,
    includeInlineTargets: true,
    isActiveNodeHandler
  });
  tinymce.canvas.addPopover(editor, HS_DATA_TOKEN, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(DataTokenPopoverManager, Object.assign({
        editor: editor,
        onInsert: handleInsertToken,
        onEdit: handleEditToken,
        onTokenRemove: getTokenRemoveHandler(editor)
      }, browserProps, renderProps));
    }
  });
  tinymce.canvas.addPopover(editor, `${HS_DATA_TOKEN}-tooltip`, {
    renderPopover() {
      return /*#__PURE__*/_jsx(DataTokenTooltipManager, {
        editor: editor
      });
    }
  });
};